import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ControlMessages } from '../../../../../shared/validators/control-messages';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldComponent implements OnChanges, OnDestroy, AfterContentInit {
  @Input() control: AbstractControl | null = null;
  @Input() fieldName: string | string[] = 'Campo';

  @HostBinding('class.form-field') readonly isFormField = true;

  @HostBinding('class.form-field--error') get hasError(): boolean {
    return this.showError;
  }

  @HostBinding('class.form-field--required') get hasRequired(): boolean {
    return this.isRequired;
  }

  @HostBinding('class.form-field--has-label') hasLabel = false;

  private destroy$ = new Subject<void>();
  private statusSub?: Subscription;

  constructor(private cd: ChangeDetectorRef, private el: ElementRef) {}

  ngAfterContentInit(): void {
    this.hasLabel = !!this.el.nativeElement.querySelector('label');
  }

  get isRequired(): boolean {
    return !!this.control?.hasValidator(Validators.required);
  }

  get showError(): boolean {
    const c = this.control;
    return !!(c?.invalid && (c?.touched || c?.dirty) && !c?.pending);
  }

  get errorMessage(): string | null {
    const c = this.control;
    if (!this.showError || !c?.errors) return null;

    const firstErrorKey = Object.keys(c.errors)[0];
    const result = ControlMessages.getErrorMessage(this.fieldName, c, firstErrorKey);
    return result ? (Object.values(result)[0] as string) : 'Campo inválido';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('control' in changes) {
      this.statusSub?.unsubscribe();
      if (this.control) {
        this.statusSub = this.control.statusChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => this.cd.markForCheck());
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
